// extracted by mini-css-extract-plugin
module.exports = {"DetailsTab":"CorporatePositions_DetailsTab__3k0Sm","spacing":"CorporatePositions_spacing__3nnks"};